import { RESPONSIVE_VARIABLES_CHANGED_EVENT } from '~/lib/constants';
// ---- internal imports ----

import useEventListener from './useEventListener';
// ---- local imports ----


function useOnResponsivityChange(handler) {
	useEventListener(document, RESPONSIVE_VARIABLES_CHANGED_EVENT, handler);
};


export default useOnResponsivityChange;
